import React, { createContext, useMemo, useContext } from "react";
import { io } from "socket.io-client";

const SocketContext = createContext(null);

export const useSocket = () => {
  const socket = useContext(SocketContext);
  console.log("hoieioswejoiwetoiwetoiwetoiweoii");
  return socket;
};

export const SocketProvider = (props) => {
  const socket = useMemo(() => io("https://tms-b.cbs.com.mm?user=admin"), []);

  return (
    <SocketContext.Provider value={socket}>
      {props.children}
    </SocketContext.Provider>
  );
};
